import axios from 'axios';
import { toast } from 'react-toastify';

export const api = axios.create({
    //baseURL: "http://hrleave.fitlk.com/api/backend"
    baseURL: "http://localhost:5198/api/backend"
});

// defining a custom error handler for all APIs
const errorHandler = (error) => {
    const statusCode = error.response?.status;
    const errorMessage = error.response?.data;

    if (error.code === "ERR_CANCELED") {
        toast.warning("Request was canceled");
        return Promise.resolve();
    }

    if (error.code === "ERR_NETWORK") {
        toast.error("Network error - Unable to connect to server. Please check your internet connection and try again.");
        return Promise.resolve();
    }

    if (statusCode) {
        switch (statusCode) {
            case 400:
                toast.error(errorMessage || "Bad request - Please check your input and try again");
                break;
            case 401:
                toast.error("Your session has expired. Please log in again.");
                // Optional: Redirect to login page
                // window.location.href = '/login';
                break;
            case 403:
                toast.error(errorMessage || "You don't have permission to perform this action");
                break;
            case 404:
                toast.error("The requested resource was not found");
                break;
            case 409:
                toast.error(errorMessage || "Conflict - The request could not be completed due to a conflict");
                break;
            case 422:
                toast.error(errorMessage || "Validation error - Please check your input");
                break;
            case 429:
                toast.warning("Too many requests - Please wait a moment and try again");
                break;
            case 500:
                toast.error(errorMessage || "Internal server error - Please try again later");
                break;
            case 502:
                toast.error("Bad gateway - The server is temporarily unavailable");
                break;
            case 503:
                toast.error("Service unavailable - Please try again later");
                break;
            case 504:
                toast.error("Request timeout - The server took too long to respond");
                break;
            default:
                toast.error(errorMessage || `An error occurred (Status: ${statusCode})`);
        }
    } else {
        toast.error("An unexpected error occurred. Please try again.");
    }

    return Promise.reject(error);
}

// registering the custom error handler to the "api" axios instance
api.interceptors.response.use(undefined, (error) => {
    return errorHandler(error)
})

// send authorization token and username
api.interceptors.request.use((config) => {
    const token = JSON.parse(localStorage.getItem('token'));
    const user = JSON.parse(localStorage.getItem('user'));
    const pcode = JSON.parse(localStorage.getItem('pcode'));

    if (token)
        config.headers.Authorization = `Bearer ${token.token}`
    if (user)
        config.headers.user = user.userName;
    if (pcode)
        config.headers.pcode = user.pcode;

    return config;
})